import axios from 'axios'

export default axios.create({
  baseURL: 'https://formular.transparex.sk/api/search',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export function searchQueryV2 (text, params = {}) {
  const query = `.*${text}.*`
  return {
    from: 0,
    size: 10,
    sort: [
      { is_terminated: { order: 'asc' } },
      '_score'
    ],
    ...params,
    query: {
      bool: {
        should: [
          {
            match_phrase_prefix: {
              name: {
                query,
                boost: 10
              }
            }
          },
          {
            match_phrase_prefix: {
              name_str: {
                query,
                boost: 15
              }
            }
          },
          {
            match_phrase_prefix: {
              name_soft: {
                query,
                boost: 0.0001
              }
            }
          },
          {
            match_phrase_prefix: {
              name_soft_2: {
                query,
                boost: 0.0001
              }
            }
          },
          {
            match_phrase_prefix: {
              names_str: {
                query,
                boost: 0.0001
              }
            }
          },
          {
            match_phrase_prefix: {
              municipality: {
                query,
                boost: 0.0001
              }
            }
          },
          {
            match_phrase_prefix: {
              cin: {
                query
              }
            }
          },
          {
            multi_match: {
              query: `${text}`,
              type: 'cross_fields',
              minimum_should_match: '50%',
              fields: [
                'name_str',
                'cin'
              ]
            }
          }
        ],
        minimum_should_match: 1
      }
    }
  }
}

export function searchQueryV3 (text, params = {}) {
  const query = `.*${text}.*`
  return {
    from: 0,
    size: 10,
    sort: [
      { is_terminated: { order: 'asc' } },
      '_score'
    ],
    ...params,
    query: {
      bool: {
        should: [
          {
            match_phrase_prefix: {
              name_soft_legal_form_edge_ngram: {
                query,
                boost: 0.01
              }
            }
          },
          {
            multi_match: {
              query: `${text}`,
              type: 'cross_fields',
              fields: [
                'name^2',
                'name_str^5',
                'name_classic',
                'name_soft_2^0.01',
                'name_soft_legal_form_edge_ngram^5',
                'names_str^0.1',
                'municipality',
                'cin'
              ],
              operator: 'and',
              tie_breaker: 1
            }
          }
        ]
      }
    }
  }
}

export function searchByCinCountry (cin, country) {
  return {
    "from": 0 ,
    "size": 10,
    "sort": [
      {
        "is_terminated": {
          "order": "asc"
        }
      },
      "_score"],
    "query": {
      "bool": {
        "must": [
          {
            "term": {
              "cin": {
                "value": cin,
                "boost": 1.0
              }
            }
          },
          {
            "match": {
              "country": country
            }
          }
        ]
      }
    }
  }
}

export function searchByTextCountry (text, country) {
  return {
    "from": 0 ,
    "size": 10,
    "sort": [
      {
        "is_terminated": {
          "order": "asc"
        }
      },
      "_score"],
    "query": {
      "bool": {
        "must": [
          {
            "bool": {
              "should":[
                {
                  "match_phrase_prefix": {
                    "name_soft_legal_form_edge_ngram": {
                      "query": `.*${text}.*`,
                      "boost": 0.01
                    }
                  }
                },
                {
                  "multi_match": {
                    "query": text,
                    "type": "cross_fields",
                    "fields": [
                      "name^2",
                      "name_str^5",
                      "name_classic",
                      "name_soft_2^0.01",
                      "name_soft_legal_form_edge_ngram^5",
                      "names_str^0.1",
                      "cin",
                      "cin_ngram^0.8"],
                    "operator": "and",
                    "tie_breaker": 1
                  }
                }
              ]
            }
          },
          {
            "match": {
              "country": country
            }
          }
        ]
      }
    }
  }
}
